import { Truck, Phone, MapPin, Recycle } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0B0C0E] pb-24 md:pb-0">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center bg-[#FF5A00] text-[#0B0C0E]">
              <Truck className="h-5 w-5" strokeWidth={2.5} />
            </span>
            <span className="font-display text-2xl tracking-wider">
              GW JUNK <span className="text-[#FF5A00]">SOLUTIONS</span>
            </span>
          </div>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-zinc-400">
            Locally owned and operated junk removal & hauling. Simple,
            stress-free, and affordable — we show up on time, work hard, and
            leave your space clutter-free.
          </p>
          <p className="mt-4 flex items-center gap-2 font-mono-ind text-[11px] uppercase tracking-widest text-zinc-500">
            <Recycle className="h-4 w-4 text-[#FF9F00]" />
            We recycle & donate whenever possible
          </p>
        </div>

        <div>
          <p className="font-mono-ind text-xs uppercase tracking-[0.3em] text-[#FF9F00]">
            Service Area
          </p>
          <ul className="mt-5 space-y-3 text-sm text-zinc-400">
            {["Cushing, OK", "Stillwater, OK", "Perkins · Yale · Ripley · Glencoe", "All of Payne County", "Noble · Pawnee · Creek · Logan Counties"].map((a) => (
              <li key={a} className="flex items-center gap-2">
                <MapPin className="h-3.5 w-3.5 text-[#FF5A00]" />
                {a}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono-ind text-xs uppercase tracking-[0.3em] text-[#FF9F00]">
            Get In Touch
          </p>
          <a
            href="tel:+19183997313"
            data-testid="footer-phone-link"
            className="mt-5 inline-flex items-center gap-3 font-display text-4xl tracking-wide text-zinc-100 transition-colors duration-300 hover:text-[#FF9F00]"
          >
            <Phone className="h-6 w-6 text-[#FF5A00]" />
            918-399-7313
          </a>
          <p className="mt-3 font-mono-ind text-[11px] uppercase tracking-widest text-zinc-500">
            Call or text — fast response, fair pricing
          </p>
        </div>
      </div>

      <div className="border-t border-[#282C34]">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-5 py-6 font-mono-ind text-[10px] uppercase tracking-[0.25em] text-zinc-600 sm:px-8 md:flex-row">
          <span>© {new Date().getFullYear()} GW Junk Solutions · Cushing, Oklahoma</span>
          <span>Big or small — we do it all</span>
        </div>
      </div>
    </footer>
  );
}
